import React from 'react';

import { Flex } from '@vimeo/bokeh';
import { useCanSeeDebugTools } from '@vimeo/live-core/store/debug';

import { InteractionDebugTool } from '../../debug/InteractionDebugTool';

export function InteractionToolsFooter() {
  const canSeeDebugTools: boolean = useCanSeeDebugTools();

  return (
    <Flex
      position={'fixed'}
      bottom={0}
      width={'100%'}
      height={0}
      flexWrap={'wrap'}
      justifyContent={'space-between'}
      alignItems={'center'}
      zIndex={9999}
    >
      {canSeeDebugTools ? <InteractionDebugTool /> : null}
    </Flex>
  );
}
